// Constantes de exibição compartilhadas entre UserTableRow e EditUserDrawer.
// Extraídas para um arquivo não-componente (regra react-refresh/only-export-components).
import type { User } from '@/types/user.types';

export const roleLabels: Record<string, string> = {
  owner: 'Proprietário',
  manager: 'Gestor',
  foreman: 'Capataz',
  cowboy: 'Vaqueiro',
};

// Rótulo + cor da pílula de assinatura (no card do produtor).
export const ASSINATURA_LABEL: Record<string, string> = {
  trial: 'Trial',
  active: 'Ativa',
  comp: 'Cortesia',
  past_due: 'Pendente',
  canceled: 'Cancelada',
  expired: 'Expirada',
  none: 'Sem assinatura',
};

export const ASSINATURA_CLASS: Record<string, string> = {
  trial: 'bg-info/10 text-info',
  active: 'bg-success/10 text-success',
  comp: 'bg-tertiary/10 text-tertiary',
  past_due: 'bg-warning/10 text-warning',
  canceled: 'bg-error/10 text-error',
  expired: 'bg-error/10 text-error',
  none: 'bg-muted text-text-secondary',
};

// Status do produtor que efetivamente cobrem o funcionário (dão acesso ativo).
export const STATUS_COBRE = new Set(['trial', 'active', 'comp', 'past_due']);

// Filtro "Ativo" da lista: trial ou assinatura valendo (cortesia e pagamento
// pendente na carência contam). Produtor pela própria assinatura, funcionário
// pela do dono. Conta bloqueada nunca é ativa.
export type FiltroUsuario = 'all' | 'ativo' | 'inativo' | 'blocked';

export function temAcesso(
  user: Pick<User, 'status' | 'isProducer' | 'assinatura' | 'coberturaHerdada'>
): boolean {
  if (user.status === 'blocked') return false;
  const status = user.isProducer ? user.assinatura?.status : user.coberturaHerdada?.status;
  return Boolean(status && STATUS_COBRE.has(status));
}

export function passaNoFiltro(
  user: Pick<User, 'status' | 'isProducer' | 'assinatura' | 'coberturaHerdada'>,
  filtro: FiltroUsuario
): boolean {
  if (filtro === 'all') return true;
  if (filtro === 'blocked') return user.status === 'blocked';
  if (user.status === 'blocked') return false;
  return filtro === 'ativo' ? temAcesso(user) : !temAcesso(user);
}

// Cor semântica da pílula de cargo por papel
export const roleClasses: Record<string, string> = {
  owner: 'bg-primary/10 text-primary',
  manager: 'bg-info/10 text-info',
  foreman: 'bg-tertiary/10 text-tertiary',
  cowboy: 'bg-warning/10 text-warning',
};

// Dias inteiros desde uma data ISO até agora — usado pra sinalizar usuário
// sem atividade recente (jornada) no UserDetailDrawer.
export function daysSince(iso: string): number {
  const diffMs = Date.now() - new Date(iso).getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}
